// Single source of truth for The Render Pros wire / ACH transfer details.
// Referenced by every client-facing payment surface (delivery, upsell /
// change-order approval, client calculator) so the bank details can never
// drift between modules. Update here and every "Pay with wire" panel follows.

export const WIRE_INSTRUCTIONS = {
  beneficiary: "THE RENDER PROS LLC",
  address: "270 Park Ave, New York, NY 10017",
  bank: "Chase Bank",
  accountNumber: "579853923",
  routingNumber: "267084131",
  swift: "CHASUS33XXX",
  currency: "USD",
  contact: "accounting@therenderpros.com",
};

// Label/value pairs in the order they should render in a details panel.
export const WIRE_ROWS = [
  ["Beneficiary", WIRE_INSTRUCTIONS.beneficiary],
  ["Address", WIRE_INSTRUCTIONS.address],
  ["Bank", WIRE_INSTRUCTIONS.bank],
  ["Account Number", WIRE_INSTRUCTIONS.accountNumber],
  ["ABA / Routing", WIRE_INSTRUCTIONS.routingNumber],
  ["SWIFT / BIC", WIRE_INSTRUCTIONS.swift],
  ["Currency", WIRE_INSTRUCTIONS.currency],
];
